import { render } from "./SelectInput.vue?vue&type=template&id=2b038149&scoped=true"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=2b038149&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b038149"]])

export default __exports__